import React from "react";
import { useSelector } from "react-redux";
import CallIcon from "@mui/icons-material/Call";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Card, IconButton, Typography } from "@mui/material";
import useMixpanel from "hooks/useMixpanel";
import { CUSTOMER_REFERRAL_EVENTS } from "utils/events";

const DEMO_CONTACTS = [
  { name: "Bhim Singh", phone: "+91 8901366610" },
  { name: "Abhikarsh Patial", phone: "+91 8901366610" },
  { name: "Meet Nagda", phone: "+91 8901366610" },
];
const ContactsList = () => {
  const { track } = useMixpanel();
  const { me } = useSelector((state) => state.app);
  const handleCallClick = (contact) => {
    const payload = {
      customer_id: me?.customerId,
      customer_name: me?.fullName,
      email: me?.email,
      timestamp: new Date().toISOString(),
      contact_name: contact.name,
      contact_phone: contact.phone,
    };

    track(CUSTOMER_REFERRAL_EVENTS.PHONE_REFERRAL_PROMO, payload);
    const formattedNumber = contact.phone.replace(/\s+/g, "");
    window.location.href = `tel:${formattedNumber}`;
  };
  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 380,
        borderRadius: 4,
        p: 2.5,
        bgcolor: "white",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        mx: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, transparent 0%, #E0E0E0 50%, #E0E0E0 100%)",
            maxWidth: "100px",
          }}
        />
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "Manrope",
            fontWeight: 500,
            lineHeight: "100%",
            letterSpacing: "0.8px",
            color: "rgba(0, 0, 0, 0.84)",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            px: 1,
          }}
        >
          CONTACTS
        </Typography>
        <Box
          sx={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, #E0E0E0 0%, #E0E0E0 50%, transparent 100%)",
            maxWidth: "100px",
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        {DEMO_CONTACTS.map((contact, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: "#F8F8F8",
              borderRadius: 2,
              p: 1.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  bgcolor: "#E6F6F4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <PersonIcon sx={{ color: "#098D83" }} />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Manrope",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  {contact.name}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Manrope",
                    fontSize: "12px",
                    color: "#666666",
                  }}
                >
                  {contact.phone}
                </Typography>
              </Box>
            </Box>
            <IconButton
              onClick={() => handleCallClick(contact)}
              sx={{
                bgcolor: "#098D83",
                width: 36,
                height: 36,
                "&:hover": {
                  bgcolor: "#076E66",
                },
              }}
            >
              <CallIcon sx={{ color: "white", fontSize: 20 }} />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Card>
  );
};
export default ContactsList;